import { flattenDeep } from 'lodash'
import * as turf from "@turf/turf";
import country_points from './country_points.json'

export const selectCountries = (data, allCountries, countriesList, country = null) => {
  let fillCountries = []
  if (country) {
    let aux = data?.map((d) => {
      return [
        d.origin.map(o => o.iso_a3),
        d.destination.map(d => d.iso_a3),
      ]
    })
    fillCountries = flattenDeep(aux)

  } else {
    // if no country selected will paint every country on the list
    fillCountries = countriesList.map((cl) => cl.iso_a3)
  }

  const finalData = allCountries.features.filter((allC) => { 
    return fillCountries.includes(allC.properties['ISO_A3'])
  })

  return {
      "type": "FeatureCollection", "features": finalData
  }
}

export const drawLines = (data, countriesList) => {  

  //TODO Do it on context
  let countriesWithLocation = countriesList?.map((cl) => {
    let point = country_points.features.find((cp) => cp.properties.iso_a3 === cl.iso_a3)
    return {
      lng: point.geometry.coordinates[0],
      lat: point.geometry.coordinates[1],
      ...cl,
    }
  })

  let lines = []
  data.forEach((d) => {
    d.origin
      .filter((origin) => origin.value !== 'All countries.ALL')
      .forEach((origin) => {
      const originWithLocation = countriesWithLocation.find(cwl => cwl.iso_a3 === origin.iso_a3)

      d.destination.forEach((destination) => {
        
        const destinationWithLocation = countriesWithLocation.find(cwl => cwl.iso_a3 === destination.iso_a3)

        lines.push(
          turf.greatCircle(
            turf.point([originWithLocation.lng, originWithLocation.lat]), 
            turf.point([destinationWithLocation.lng, destinationWithLocation.lat])
          ),
        )
      })
    })
  })

  return {
    "type": "FeatureCollection", "features": lines
  }
}
